import { createRouter, createWebHistory } from 'vue-router'
import i18n from '@/i18n'

// Pages publiques
import Connect from '@/components/LoginPage.vue'
import Chat from '@/components/ChatPage.vue'
import SignupPage from '@/components/SignupPage.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import CreateAgent from '@/components/CreateAgentForm.vue'
import SelectAgent from '@/components/SelectAgent.vue'

// Layout APP
import AppLayout from '@/components/AppPage.vue'

// Pages app

import Dashboard from '@/components/DashboardComponent.vue'
import TestLive from '@/components/TestLive.vue'
import TelephonyPage from '@/components/TelephonyPage.vue'

import Booking from '@/components/BookingComponent.vue'
import BookingList from '@/components/BookingRealComponent.vue'

import EmailSmsTemplates from '@/components/EmailSmsTemplates.vue'
import AjouterModifierAgent from '@/components/AgentSettingsPage.vue'
import Modules from '@/components/ModulesComponent.vue'
import Knowledge from '@/components/BasesDeConnaissance.vue'
import Personality from '@/components/PersonnaliteComportement.vue'
import Channels from '@/components/CanauxConnectes.vue'
import Leads from '@/components/CollecteClients.vue'
import History from '@/components/HistoriqueConversations.vue'
import Plan from '@/components/PlanRequetes.vue'
import Settings from '@/components/ParametresAvances.vue'
import Support from '@/components/SupportAssistance.vue'
import MCP from '@/components/MCP.vue'
import Live from '@/components/LiveMonitorPage.vue'
import Workflows from '@/components/WorkflowFlowBuilderPage.vue'
import PaymentSuccess from '@/components/PaymentSuccess.vue'
import PaymentCancel from '@/components/PaymentCancel.vue'

const routes = [

  // ======================
  // ROOT
  // ======================
  {
    path: '/',
    redirect: '/sign-in'
  },
  {
    path: '/import-agent',
    name: 'ImportAgent',
    component: () => import('@/components/ImportAgent.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/components/CreateAccount.vue')
  },
  
  // ======================
  // DEMO
  // ======================
  { path: '/chat', component: Chat },


  // ======================
  // AUTH
  // ======================
  { path: '/sign-in', component: Connect },
  { path: '/signup', component: SignupPage },
  { path: '/forgot-password', component: ForgotPassword },

  // ======================
  // AGENTS
  // ======================
  { path: '/agents', component: SelectAgent },
  { path: '/create-agent', component: CreateAgent },
  { path: '/payment-success', component: PaymentSuccess },
  { path: '/payment-cancel', component: PaymentCancel },

  // ======================
  // APP (🔥 IMPORTANT)
  // ======================
  {
    path: '/app',
    component: AppLayout,
    children: [
      { path: '', redirect: '/app/dashboard' },

      { path: 'live-monitor', component: Live },
      { path: 'dashboard', component: Dashboard },
      { path: 'test-live', component: TestLive },
      { path: 'telephony', component: TelephonyPage },
      
      { path: 'booking', component: BookingList },
      { path: 'booking/settings', component: Booking },
      { path: 'templates', component: EmailSmsTemplates },
      { path: 'agent', component: AjouterModifierAgent },
      { path: 'modules', component: Modules },
      { path: 'knowledge', component: Knowledge },
      { path: 'personality', component: Personality },
      { path: 'channels', component: Channels },
      { path: 'leads', component: Leads },
      { path: 'history', component: History },
      { path: 'workflows', component: Workflows },
      { path: 'plan', component: Plan },
      { path: 'settings', component: Settings },
      { path: 'support', component: Support },
      { path: 'mcp', component: MCP }
    ]
  },

  // ======================
  // 🇫🇷 VERSION
  // ======================
  {
    path: '/fr',
    redirect: '/fr/sign-in'
  },

  { path: '/fr/sign-in', component: Connect },
  { path: '/fr/signup', component: SignupPage },
  { path: '/fr/forgot-password', component: ForgotPassword },

  { path: '/fr/agents', component: SelectAgent },
  { path: '/fr/create-agent', component: CreateAgent },

  {
    path: '/fr/app',
    component: AppLayout,
    children: [
      { path: '', redirect: '/fr/app/dashboard' },

      { path: 'dashboard', component: Dashboard },
      { path: 'booking', component: Booking },
      { path: 'templates', component: EmailSmsTemplates },
      { path: 'agent', component: AjouterModifierAgent },
      { path: 'modules', component: Modules },
      { path: 'knowledge', component: Knowledge },
      { path: 'personality', component: Personality },
      { path: 'channels', component: Channels },
      { path: 'leads', component: Leads },
      { path: 'history', component: History },
      { path: 'workflows', component: Workflows },
      { path: 'plan', component: Plan },
      { path: 'settings', component: Settings },
      { path: 'support', component: Support },
      { path: 'mcp', component: MCP }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

/**
 * 🌍 SYNC LANG
 */
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/fr')) {
    i18n.global.locale = 'fr'
    localStorage.setItem('lang', 'fr')
  } else {
    i18n.global.locale = 'en'
    localStorage.setItem('lang', 'en')
  }
  next()
})

export default router
